import { EDIT_LISTING_AMENITIES,
         CLOSE_LISTING_AMENITIES,
         PENDING_SUBMIT_LISTING_AMENITIES,
         COMPLETE_SUBMIT_LISTING_AMENITIES,
         FAILED_SUBMIT_LISTING_AMENITIES
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyamenitiesediting: false
}


const mlListingAmenities = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_AMENITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyamenitiesediting: true
        }

        case CLOSE_LISTING_AMENITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyamenitiesediting: false
        }

        case PENDING_SUBMIT_LISTING_AMENITIES: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_AMENITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_AMENITIES: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingAmenities